import React from "react"
import PropTypes from "prop-types"

import StandardModal from '../app_components/StandardModal'


class SelectResourceLanguage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalOpen: false,
      loaded: false,
      languageChoices: []
    }

    this.toggleModal = this.toggleModal.bind(this)
    this.selectNewLanguage = this.selectNewLanguage.bind(this)
  }

  componentWillMount() {
    $.ajax({
      url: `../ajaxGetLanguages`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          languageChoices: data.data.allLanguages,
          loaded: true
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  toggleModal() {
    this.setState({
      modalOpen: !this.state.modalOpen
    })
  }

  selectALanguage() {
    return this.state.languageChoices.map((language, index) => {
      return(
        <h3 key={index} onClick={() => this.selectNewLanguage(language)} className="itemPickerText">{language.language}</h3>
      )
    })
  }

  selectNewLanguage(language) {
    window.location.replace(`../language_resources/books?language=${language.language}`)
  }

  render() {
    return(
      <div>
        <h1
          onClick={this.toggleModal}
          className="onboardingModalHeader"
          style={{cursor: 'pointer', paddingBottom: 13, marginBottom:0}}>Change Language</h1>
        {(this.state.modalOpen && this.state.loaded) &&
          <StandardModal onClose={this.toggleModal} title="Select a language">
            <div>
              <h3 className="statusHeaderSectionText" style={{alignSelf: 'center'}}>Select a language</h3>
              <div className="itemPickerContainer" style={{marginTop: 20}}>
                  {this.selectALanguage()}
              </div>
            </div>
          </StandardModal>
        }
      </div>
    )
  }
}

export default SelectResourceLanguage;
